module.exports = __webpack_public_path__ + "img/Elo.8ceab945.svg";